module.exports = __webpack_public_path__ + "img/3.d2e8dfa5.jpg";